import { render, staticRenderFns } from "./CoursesTable.vue?vue&type=template&id=122898bb&scoped=true&"
import script from "./CoursesTable.vue?vue&type=script&lang=js&"
export * from "./CoursesTable.vue?vue&type=script&lang=js&"
import style0 from "./CoursesTable.vue?vue&type=style&index=0&id=122898bb&scoped=true&lang=scss&"
import style1 from "./CoursesTable.vue?vue&type=style&index=1&id=122898bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122898bb",
  null
  
)

export default component.exports